import map from 'lodash/map';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Form from '@spothero/ui/form';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import Radio from '@spothero/ui/radio';
import RadioGroup from '@spothero/ui/radio-group';
import Sprite from '@spothero/ui/sprite';
import Icon from 'common/icon/Icon';
import AddNewCardForm from './AddNewCardForm';

export default class CreditCardSelect extends Component {
    static propTypes = {
        user: PropTypes.object,
        selectedCard: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool
        ]),
        onCardSelected: PropTypes.func
    };

    constructor(props) {
        super(props);

        const {
            user,
            selectedCard
        } = props;
        const cards = this._getUserCards(user, selectedCard);

        this.state = {
            cards,
            newCreditCard: (cards.length === 0 || selectedCard === 'new')
        };
    }

    _onCardSelected = evt => {
        const {
            onCardSelected
        } = this.props;
        const value = evt.target.value;

        this.setState({
            newCreditCard: (value === 'new')
        });

        if (onCardSelected) {
            onCardSelected(value);
        }
    }

    _getUserCards(user, selectedCard) {
        let items = [];

        if (user.creditCards.length) {
            items = map(user.creditCards, (card, i) => {
                const cardTypeFormatted = card
                    .type
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '');

                return {
                    label: <Fragment>{this._getCardInitials(cardTypeFormatted)}<sup>*</sup>{card.last4}</Fragment>,
                    value: `${card.id}`,
                    checked: ((selectedCard !== 'new' && !i) || selectedCard === card.id),
                    cardTypeFormatted
                };
            }).concat([
                {
                    label: 'Add new card',
                    value: 'new',
                    checked: (selectedCard === 'new')
                }
            ]);
        }

        return items;
    }

    _renderCardSprite(cardType) {
        return <Sprite name={`cc-${cardType}-small`} />;
    }

    _getCardInitials(cardType) {
        switch (cardType) {
            case 'mastercard':
            case 'maestro':
                return 'MC';

            case 'american-express':
                return 'AMEX';

            case 'discover':
                return 'DISC';

            case 'diners-club':
                return 'DC';

            default:
                return cardType.toUpperCase();
        }
    }

    submit() {
        if (this.state.newCreditCard) {
            const newCardFormData = this._addNewCardForm.submit();

            if (!newCardFormData) { return false; }

            return {
                ...newCardFormData,
                selectedCreditCard: 'new'
            };
        } else {
            return this._creditCard.submit();
        }
    }

    render() {
        const {
            user: {
                isCheckoutSecurePayment
            }
        } = this.props;
        const {
            cards,
            newCreditCard
        } = this.state;
        const classes = classNames(
            'CreditCardSelect',
            {'CreditCardSelect-secure': isCheckoutSecurePayment}
        );

        return (
            <div className={classes}>
                {(cards.length > 0) &&
                    <Form
                        ref={node => { this._creditCard = node; }}
                        id="CreditCardSelect-form"
                    >
                        <p>Choose payment method:</p>
                        <FormGroup>
                            <RadioGroup
                                id="CreditCardSelect-card-options"
                                name="selectedCreditCard"
                                className="CreditCardSelect-options"
                                onChange={this._onCardSelected}
                            >
                                {map(cards, (card, i) => {
                                    return (
                                        <Radio
                                            key={i}
                                            label={(
                                                <Label>
                                                    {card.cardTypeFormatted &&
                                                        this._renderCardSprite(card.cardTypeFormatted)
                                                    }
                                                    {card.label}
                                                </Label>
                                            )}
                                            value={card.value}
                                            defaultChecked={card.checked}
                                        />
                                    );
                                })}
                            </RadioGroup>
                        </FormGroup>
                    </Form>
                }
                {newCreditCard &&
                    <AddNewCardForm ref={node => { this._addNewCardForm = node; }} />
                }
                {isCheckoutSecurePayment &&
                    <Fragment>
                        <Icon
                            name="lock"
                            size={12}
                        />
                        <small>Secure and encrypted payment</small>
                    </Fragment>
                }
            </div>
        );
    }
}
